export const changeText = (text: any) =>
  text
    ?.split('\n')
    .join('')
    ?.split('\b')
    .join('')
    ?.split('\\')
    .join('');
